export default __webpack_public_path__ + "static/media/topic900bg.11c504f2.png";